import { render, staticRenderFns } from "./File1.vue?vue&type=template&id=63d30e41&scoped=true"
import script from "./File1.vue?vue&type=script&lang=js"
export * from "./File1.vue?vue&type=script&lang=js"
import style0 from "./File1.vue?vue&type=style&index=0&id=63d30e41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d30e41",
  null
  
)

export default component.exports